import { Pipe, PipeTransform } from '@angular/core';
import { EnumDigital } from '@libs/constants';
import { Util } from '@libs/utilities/util';


/**------------------------------------------------------
 * Digital Unit Conversion
 * --------------
 * Takes an exponent argument that defaults to 1.
 * Usage:
 * 	value (size in bytes) | unit : "B":"MB" (or other)
 * Example:
 * 	{{ totalSizeInBytes | unit: "B":"MB" }}
 *  formats "bytes" from totalSizeInBytes to "megabytes"
 */
@Pipe({
    name: 'ngDigitalUnit',
    standalone: false
})
export class NgDigitalUnitPipe implements PipeTransform {

	transform(value: number, fromUnit: EnumDigital, toUnit: EnumDigital): number {

		//0 - check if the passed units are valid
		if (!fromUnit) throw new Error(`NgDigitalUnitPipe => transform => FATAL ERROR: mapFromUnit can not be defined for fromUnit of "${fromUnit}" is invalid`);
		if (!toUnit)   throw new Error(`NgDigitalUnitPipe => transform => FATAL ERROR: mapToUnit can not be defined for toUnit of "${toUnit}" is invalid`);

		//1 - convert the digital units
		return Util.Convert.convertDigital(value, fromUnit, toUnit);
	}
}
